import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 214px;
  max-height: 200px;
  padding: 8px 6px;
  border-radius: 8px;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  z-index: 10;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
  limitOfLines?: number;
}

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};

  &.help {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
    margin-left: 8px;
  }

  &.tabble-header {
    font-size: 12px;
    font-weight: 400;
    color: #8f95b2;
  }

  &.tabble-row {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;

  margin-top: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 216px;
  width: 100%;
  height: 34px;
  padding: 6px 10px;

  &.pictureInputs {
    width: 100%;
  }

  &.search-selectedItems {
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
    border-radius: 4px;
  }
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
